module.exports = __webpack_public_path__ + "static/media/Item_Row_Gold@3x.06cf5025.png";